import { getGivenName, userIsRegistered } from '../../../../../../../../common/users/userHelper';
import { MNUser } from '../../../../../../../../common/users/userModelTypes';
import { getUserId } from '../../../../../../../../common/users/utils/userPropertyUtils';

export const getPopupSelectorId = ({ user }: { user: MNUser }) => user && `user-permission-${getUserId(user)}`;

export const getUserEntryName = ({ user, isCurrentUser }: { user: MNUser; isCurrentUser: boolean }) => {
    if (isCurrentUser) return 'yourself';
    if (userIsRegistered(user)) return getGivenName(user);
    return 'this user';
};
